import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { FetchBoardsPayload, FetchBoardsSuccessResponse } from '../../types';
import { getBoards } from '../../services';
import { FIVE_MINUTES } from '@constants';
import { boardQueryKeys } from './boardQueryKeys';
import { useCallback } from 'react';

export const useBoardsQuery = ({
  shouldFetchDefaultBoard = false,
  ...params
}: Omit<FetchBoardsPayload, 'is_integration'> & {
  shouldFetchDefaultBoard?: boolean;
}) => {
  const isIntegration = shouldFetchDefaultBoard;

  const { data: queryData, ...boardQuery } = useAppQuery<{
    data: FetchBoardsSuccessResponse;
  }>({
    queryKey: boardQueryKeys.list({
      ...params,
      is_integration: isIntegration,
      identifier: `useBoardsQuery`,
    }),
    queryFn: async ({ token }) =>
      getBoards({
        params: {
          ...params,
          is_integration: isIntegration,
        },
        token,
      }).then((response) => ({ data: response.data as FetchBoardsSuccessResponse })),
    staleTime: FIVE_MINUTES,
    // Only run query when team_id is provided
    enabled: !!params.team_id,
  });

  const getDefaultBoard = useCallback(() => {
    return queryData?.data.find((board) => board.slug === 'import');
  }, [queryData?.data]);

  return {
    getDefaultBoard,
    boards: queryData?.data,
  };
};
